import { CSSProperties, Fragment } from 'react';

import { Divider, FlexAligner } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { HotKeyLineWithButtonAndDescription } from '@/components/HotKeyLineWithButtonAndDescription.tsx';
import { LayoutHotkeyNames } from '@/hooks/shortcutHooks/hotkeys/types.ts';
import { useLayoutHotkeysDefinitions } from '@/hooks/shortcutHooks/useHotkeyDefinitions/useLayoutHotkeysDefinitions.tsx';
import { responsive } from '@/utils';

const DEFAULT_STYLE: CSSProperties = {
  width: '32rem',
  height: 'fit-content',
};

const renderDividerAfter: number[] = [1, 2];

type LayoutShortcutsProps = {
  style?: CSSProperties;
};

export const LayoutShortcuts = ({ style = DEFAULT_STYLE }: LayoutShortcutsProps) => {
  const { t } = useTranslation(['landingPage']);
  const layoutHotkeys = useLayoutHotkeysDefinitions();
  return (
    <FlexAligner
      direction='column'
      alignment={'center'}
      style={{ ...style }}
      gap={responsive.spacing['3xlarge']}
    >
      {(Object.keys(layoutHotkeys) as LayoutHotkeyNames[]).map((key, index) => {
        const props = layoutHotkeys[key];
        if (props.disabled) return null;
        const shortcutLine = (
          <HotKeyLineWithButtonAndDescription key={props.primary.code} {...props} />
        );

        if (renderDividerAfter.includes(index)) {
          return (
            <Fragment key={props.primary.code}>
              {shortcutLine}
              <Divider />
            </Fragment>
          );
        }
        return shortcutLine;
      })}
      <HotKeyLineWithButtonAndDescription
        key={'numKeyStrokes'}
        hotkeyModifier={{ modifier: 'Shift' }}
        description={t('landingPage:getStartedWizard.keyboardShortcuts.shortcuts.anyNumberLabel')}
        primary={{
          keyboardKey: t('landingPage:getStartedWizard.keyboardShortcuts.shortcuts.anyNumber'),
          code: 'Any Number Key',
        }}
      />
    </FlexAligner>
  );
};
